import { Note } from "@models/note.model.ts";
import { NoteSerializer } from "@models/serializers/noteSerializer.ts";
import { httpRequest } from "../../http";

export class CommandMoveNote {

    async run(notebookId: number, note: Note) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/${note.id}/`
        try {
            const response = await httpRequest<any>(url, {
                method: "PATCH",
                body: {
                    parent_id: note.parent_id
                },
            });
            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Note []{
        const serializer = new NoteSerializer();
        return serializer.deserialize(data);
    }

}

